@if (image) {
  <div class="d-flex flex-column align-items-center margin-xl tool-item">
    <img [src]="'static/assets/images/' + image.src" alt="" [width]="image.width" />
    <h3 [ngClass]="{ 'd-flex align-items-center justify-content-center gap-2': chipLabel }">
      {{ label | translate }}
      @if (chipLabel) {
        <ds-chip
          [text]="chipLabel | translate"
          [colorVariant]="chipColorVariant"
          [size]="DsChipSize.Small"
          data-test-id="tool-chip"
        ></ds-chip>
      }
    </h3>
    @if (downloadType === DownloadType.button) {
      <button type="button" ds-button [variant]="buttonVariant" (click)="download(tool)" [disabled]="disabled">
        {{ buttonName | translate }}
      </button>
    }
    @if (downloadType === DownloadType.internal_link) {
      <button ds-button [variant]="buttonVariant" type="button" [routerLink]="url" [disabled]="disabled">
        {{ buttonName | translate }}
      </button>
    }
    @if (downloadType === DownloadType.external_link) {
      <a
        [href]="url"
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-primary btn-lg"
        data-test-id="external-link"
        (click)="onClick.emit()"
      >
        <span class="margin-right-sm">{{ buttonName | translate }}</span>
        <svg aria-hidden="true"><use xlink:href="#external-link"></use></svg>
      </a>
    }
    @if (downloadType === DownloadType.install) {
      <button type="button" (click)="install(tool)" ds-button [variant]="buttonVariant" [disabled]="disabled">
        {{ buttonName | translate }}
      </button>
    }
    @if (downloadType === DownloadType.dropdown) {
      <div ngbDropdown class="d-inline-block" data-test-id="tools-dropdown">
        <button
          [id]="'dropdown_' + dropdownOption[0].tool"
          ds-button
          [variant]="buttonVariant"
          ngbDropdownToggle
          [disabled]="disabled"
        >
          {{ buttonName | translate }}
        </button>
        <div ngbDropdownMenu [attr.aria-labelledby]="'dropdown_' + dropdownOption[0].tool" role="menu">
          @for (toolItem of dropdownOption; track $index) {
            <button
              ngbDropdownItem
              [ngClass]="{ 'tool-dropdown-item-with-icon': toolItem.icon }"
              (click)="handleDropdownClick(toolItem)"
              role="menuitem"
            >
              @if (toolItem.icon; as icon) {
                <ds-icon [icon]="icon"></ds-icon>
              }
              {{ toolItem.label | translate }}
            </button>
          }
        </div>
      </div>
    }
  </div>
}
